import { render, staticRenderFns } from "./SupplierManufacturingTransport.vue?vue&type=template&id=ce621c18&scoped=true&"
import script from "./SupplierManufacturingTransport.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce621c18",
  null
  
)

export default component.exports